import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "item-list" }

import { toRefs } from 'vue'
interface PROPS {
  title: string
  selected: boolean
}

export default /*@__PURE__*/_defineComponent({
  __name: 'FileListItem',
  props: {
    title: {},
    selected: { type: Boolean }
  },
  setup(__props: any) {

const props = __props
const { title = 'No title', selected } = toRefs(props)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["list-item", [_unref(selected) ? 'selected' : 'not-selected']])
  }, [
    _createElementVNode("span", _hoisted_1, _toDisplayString(_unref(title)), 1)
  ], 2))
}
}

})